import { getAkBackendHealth } from '../../services';
import useOverviewCheck from './useOverviewCheck';
import OverviewCardShell from './OverviewCardShell';

export default function AkBackendCard() {
  const { data, isLoading, error } = useOverviewCheck(getAkBackendHealth);

  return (
    <OverviewCardShell title="AK Backend" isLoading={isLoading} error={error} good={data?.good}>
      {data && (
        <div className="space-y-1 text-sm text-slate-700">
          <p>
            <span className="font-semibold">{data.total_requests.toLocaleString()}</span> requests
            ({data.service_callback}, {data.range_minute} phút gần nhất)
          </p>
          <p>
            Error rate:{' '}
            <span className={data.error_rate >= data.error_rate_threshold ? 'font-bold text-amber-600' : 'font-bold'}>
              {(data.error_rate * 100).toFixed(1)}%
            </span>{' '}
            <span className="text-xs text-slate-400">(ngưỡng {(data.error_rate_threshold * 100).toFixed(0)}%)</span>
          </p>
          <p>
            Avg latency:{' '}
            <span className={data.avg_latency >= data.avg_latency_threshold ? 'font-bold text-amber-600' : 'font-bold'}>
              {data.avg_latency}ms
            </span>{' '}
            <span className="text-xs text-slate-400">(ngưỡng {data.avg_latency_threshold}ms)</span>
          </p>
        </div>
      )}
    </OverviewCardShell>
  );
}
